import React, { useState } from "react";

import ProductsSearch from "@admin/components/ProductsSearch";
import type ComplexPromotionLevelModel from "@admin/domain/complexPromotions/models/ComplexPromotionLevelModel";

type GiftOptions = NonNullable<ComplexPromotionLevelModel[`gift_options`]>;

type Props = {
    levelIndex: number;
    level: ComplexPromotionLevelModel;
};

const GiftOptions: React.FC<Props> = ({ levelIndex, level }) => {
    const [giftOptions, setGiftOptions] = useState<GiftOptions>(level.gift_options || []);

    const addGiftOption = (): void => setGiftOptions([...giftOptions, {}]);

    const updateGiftOption = (
        giftIndex: number,
        productId: string | null | undefined,
        productTitle: string | null | undefined,
    ): void => {
        setGiftOptions(
            giftOptions.map((gift, index) => {
                return giftIndex === index
                    ? {
                          product_id: productId || undefined,
                          product_title: productTitle || undefined,
                      }
                    : gift;
            }),
        );
    };

    const deleteGiftOption = (giftIndex: number): void => {
        setGiftOptions(giftOptions.filter((_gift, index): boolean => giftIndex !== index));
    };

    return (
        <div className="rounded border p-10 my-5 me-5">
            <h3>Подарки на выбор</h3>

            {giftOptions.map((gift, giftIndex) => (
                <div
                    key={`${gift.product_id || `new-gift-option`}-${giftIndex}`}
                    className="rounded border p-6 my-5 me-5"
                >
                    <ProductsSearch
                        label="Подарок"
                        inputName={`levels[${levelIndex}][gift_options][${giftIndex}][product_id]`}
                        productId={gift.product_id}
                        productTitle={gift.product_title}
                        onChange={(productId, productTitle): void =>
                            updateGiftOption(giftIndex, productId, productTitle)
                        }
                    />

                    <button
                        type="button"
                        className="btn btn-danger btn-sm"
                        onClick={(): void => deleteGiftOption(giftIndex)}
                    >
                        Удалить
                    </button>
                </div>
            ))}

            <button type="button" className="btn btn-primary" onClick={addGiftOption}>
                Добавить подарок на выбор
            </button>
        </div>
    );
};

export default GiftOptions;
